// extracted by mini-css-extract-plugin
export var active = "_i7-2";
export var recordingDot = "_i7-1";
export var recordingIndicator = "_i7-0";